import { createTypes } from 'redux-action-creator'

const actionTypes = createTypes([
  'CREATED',
  'MODIFIED',
  'DISMISS_STICKY'
], 'GROUP')

export { actionTypes }
